import React, { createContext, useContext, useMemo, useState } from 'react';
type SessionValue = {
  isLoggedIn: boolean;
  firstName: string;
  championEligible: boolean;
  championPlayerName: string;
  hasIncompleteRegistration: boolean;
  championBannerDismissed: boolean;
  cartCount: number;
  dismissChampionBanner: () => void;
  resetChampionBanner: () => void;
  addToCart: (qty: number) => void;
  login: () => void;
  logout: () => void;
  setChampionEligible: (value: boolean) => void;
  setHasIncompleteRegistration: (value: boolean) => void;
};
type SessionProviderProps = {
  children: React.ReactNode;
  startLoggedIn: boolean;
  championEligible: boolean;
  hasIncompleteRegistration: boolean;
};
const SessionContext = createContext<SessionValue | null>(null);
export function SessionProvider({
  children,
  startLoggedIn,
  championEligible: initialEligible,
  hasIncompleteRegistration: initialIncomplete
}: SessionProviderProps) {
  const [isLoggedIn, setIsLoggedIn] = useState(startLoggedIn);
  const [championEligible, setChampionEligible] = useState(initialEligible);
  const [hasIncompleteRegistration, setHasIncompleteRegistration] = useState(initialIncomplete);
  const [championBannerDismissed, setDismissed] = useState(false);
  const [cartCount, setCartCount] = useState(1);
  const value = useMemo<SessionValue>(() => ({
    isLoggedIn,
    firstName: championEligible ? 'David' : 'Morgan',
    championEligible,
    championPlayerName: 'David',
    hasIncompleteRegistration,
    championBannerDismissed,
    cartCount,
    dismissChampionBanner: () => setDismissed(true),
    resetChampionBanner: () => setDismissed(false),
    addToCart: qty => setCartCount(c => c + qty),
    login: () => setIsLoggedIn(true),
    logout: () => setIsLoggedIn(false),
    setChampionEligible,
    setHasIncompleteRegistration
  }), [isLoggedIn, championEligible, hasIncompleteRegistration, championBannerDismissed, cartCount]);
  return <SessionContext.Provider value={value} data-id="element-253" data-mp="1ul1g507r3xi8">{children}</SessionContext.Provider>;
}
export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used inside SessionProvider');
  return ctx;
}